module.exports = __webpack_public_path__ + "img/no-cache-instructor.05bffd5b.jpg";